import { render, staticRenderFns } from "./SalesStatistics.vue?vue&type=template&id=2560bef0&"
import script from "./SalesStatistics.vue?vue&type=script&lang=js&"
export * from "./SalesStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SalesStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports